import Coverages from '../Profile/Coverages';

const NewspagerCompany = ({
    coverages,
    coveragesTotal,
    stories,
    news_stories,
    companySlug,
}) => {
    return (
        <>
            <Coverages
                data={coverages}
                total={coveragesTotal}
                companySlug={companySlug}
            />
        </>
    );
};

export default NewspagerCompany;
